import { createSelector } from 'reselect';
import { getContacts } from '@epi-selectors/api';
import { IContact } from '@epi-models/pages/CompanyInfo';
import { orderBy } from 'lodash';

export interface ContactsOrder {
  sortingBy: string;
  ascending: boolean;
}

export interface CompanyInfoState {
  contactsOrder: ContactsOrder;
  editMode: boolean;
  showSlideout: boolean;
  slideoutEditMode: boolean;
  rehydrated?: boolean;
}

export const getContactsOrder = (state): ContactsOrder =>
  state.companyInfo.contactsOrder;

export const getOrderedContacts = createSelector(
  getContacts,
  getContactsOrder,
  (contacts, order): IContact[] => {
    if (!order) {
      return contacts;
    }

    return orderBy(
      contacts,
      item => `${item[order.sortingBy]}`.toLowerCase(),
      order.ascending ? 'asc' : 'desc'
    );
  }
);

export const getShowSlideout = (state): boolean =>
  state.companyInfo.showSlideout;

export const getSlideoutEditMode = (state): boolean =>
  state.companyInfo.slideoutEditMode;

export const getEditMode = (state): boolean => state.companyInfo.editMode;
